import QtdModulo from '../../ModulosCrefito/QtdModulo'
import Epi from '../../ModulosCrefito/Modulos/Epi'
import ParametrosAssistenciais from '../../ModulosCrefito/Modulos/ParametrosAssistenciais'
import RegistroProntuario from '../../ModulosCrefito/Modulos/RegistroProntuario'
import OutrosDados from '../../ModulosCrefito/Modulos/OutrosDados'
import OrientacoesNotificacao from '../../ModulosCrefito/Modulos/OrientacoesNotificacao'
import CapsPsicossocial from '../../ModulosCrefito/Modulos/CapsPsicossocial'
import ResponsavelFisc from '../../ModulosCrefito/Modulos/ResponsavelFisc'
import ResponsavelTec from '../../ModulosCrefito/Modulos/ResponsavelTec'
import ProfissionaisNoEstabelecimento from '../../ModulosCrefito/Modulos/ProfissionaisNoEstabelecimento'
import ServicoNaUnidade from '../../ModulosCrefito/Modulos/ServicoNaUnidade'
import Estagio from '../../ModulosCrefito/Modulos/Estagio'
import RecursoEstrutura from '../../ModulosCrefito/Modulos/RecursoEstrutura'
import SituacoesNaFiscalizacao from '../../ModulosCrefito/Modulos/SituacoesNaFiscalizacao'
import PessoaNaoHabilitada from '../../ModulosCrefito/Modulos/PessoaNaoHabilitada'
import SetoresAssistencia from '../../ModulosCrefito/Modulos/SetoresAssistencia'
import NasfModalidades from '../../ModulosCrefito/Modulos/NasfModalidades'
import NasfMunicipio from '../../ModulosCrefito/Modulos/NasfMunicipio'
import LegalidadeCofito517 from '../../ModulosCrefito/Modulos/LegalidadeCofito517'
import Publicidade from '../../ModulosCrefito/Modulos/Publicidade'
import PublicidadeRedeSocial from '../../ModulosCrefito/Modulos/PublicidadeRedeSocial'
import SetoresIlpis from '../../ModulosCrefito/Modulos/SetoresIlpis'
import HigienizacaoSanitizacao from '../../ModulosCrefito/Modulos/HigienizacaoSanitizacao'
import SetoresComFisio from '../../ModulosCrefito/Modulos/SetoresComFisio'
import Emergencia from '../../ModulosCrefito/Modulos/Emergencia'
import Uti from '../../ModulosCrefito/Modulos/Uti'
import Uci from '../../ModulosCrefito/Modulos/Uci'
import Ucin from '../../ModulosCrefito/Modulos/Ucin'
import Enfermaria from '../../ModulosCrefito/Modulos/Enfermaria'
import Transporte from '../../ModulosCrefito/Modulos/Transporte'
import Ambulatorio from '../../ModulosCrefito/Modulos/Ambulatorio'
import Residencia from '../../ModulosCrefito/Modulos/Residencia'
import AtribuicoesExtra from '../../ModulosCrefito/Modulos/AtribuicoesExtra'
import CER from '../../ModulosCrefito/Modulos/CER'
import Terceirizados from '../../ModulosCrefito/Modulos/Terceirizados'
import Fiscalizadores from '../../ModulosCrefito/Modulos/Fiscalizadores'
import React from 'react'

const Livre = () => {
    return (
        <>
            <Fiscalizadores modulo="fiscalizadores" />
            <QtdModulo texto="SERVIÇOS TERCEIRIZADOS" modulo="terceirizados" />
            <Terceirizados modulo="terceirizados" />
            <QtdModulo texto="EQUIPAMENTO DE PROTEÇÃO INDIVIDUAL" modulo="epi" />
            <Epi modulo="epi" />
            <QtdModulo texto="PARÂMETROS ASSISTENCIAIS" modulo="parametros" />
            <ParametrosAssistenciais modulo="parametros" />
            <QtdModulo texto="REGISTRO EM PRONTUÁRIO" modulo="prontuario" />
            <RegistroProntuario modulo="prontuario" />
            <QtdModulo texto="CENTRO DE ATENÇÃO PSICOSSOCIAL" modulo="psicossocial" />
            <CapsPsicossocial modulo="psicossocial" />
            <QtdModulo texto="RESPONSÁVEL PELO RECEBIMENTO DA FISCALIZAÇÃO" modulo="responsavelfisc" />
            <ResponsavelFisc modulo="responsavelfisc" />
            <QtdModulo texto="RESPONSÁVEL TÉCNICO FISIOTERAPEUTA" modulo="responsaveltec" />
            <ResponsavelTec modulo="responsaveltec" />
            <QtdModulo texto="FISIOTERAPEUTAS QUE TRABALHAM NO ESTABELECIMENTO" modulo="profissionais" />
            <ProfissionaisNoEstabelecimento modulo="profissionais" />
            <QtdModulo texto="SERVIÇO NA UNIDADE" modulo="servico" />
            <ServicoNaUnidade modulo="servico" />
            <QtdModulo texto="ESTÁGIO" modulo="estagios" />
            <Estagio modulo="estagios" />
            <QtdModulo texto="RECURSOS/ESTRUTURA FÍSICA" modulo="recursoestrutura" />
            <RecursoEstrutura modulo="recursoestrutura" />
            <QtdModulo texto="SITUAÇÕES CONSTATADAS DURANTE A FISCALIZAÇÃO" modulo="situacoes" />
            <SituacoesNaFiscalizacao modulo="situacoes" />
            <QtdModulo texto="EXERCÍCIO ILEGAL" modulo="naohabilitada" />
            <PessoaNaoHabilitada modulo="naohabilitada" />
            <QtdModulo texto="SETORES DE ASSISTÊNCIA" modulo="assistencia" />
            <SetoresAssistencia modulo="assistencia" />
            <QtdModulo texto="MODALIDADE DE NASF-AB" modulo="nafs" />
            <NasfModalidades modulo="nafs" />
            <QtdModulo texto="ATUAÇÃO DO NASF NO MUNICÍPIO" modulo="nasfmunicipio" />
            <NasfMunicipio modulo="nasfmunicipio" />
            <QtdModulo texto="RESOLUÇÃO COFFITO Nº 517/2020 - NOTA TÉCNICA ANVISA 04/2020 e 07/2020" modulo="nasflegalidade" />
            <LegalidadeCofito517 modulo="nasflegalidade" />
            <QtdModulo texto="REDE SOCIAL - PUBLICIDADE IRREGULAR" modulo="idprofissional" />
            <PublicidadeRedeSocial modulo="idprofissional" />
            <QtdModulo texto="PUBLICIDADE" modulo="publicidade" />
            <Publicidade modulo="publicidade" />
            <QtdModulo texto="ILPIS" modulo="setoresilpis" />
            <SetoresIlpis modulo="setoresilpis" />
            <QtdModulo texto="MEDIDAS DE HIGIENIZAÇÃO E SANITIZAÇÃO" modulo="sanitizacao" />
            <HigienizacaoSanitizacao modulo="sanitizacao" />
            <QtdModulo texto="SETORES DE ASSISTÊNCIA QUE POSSUEM FISIOTERAPEUTA" modulo="setorcomfisio" />
            <SetoresComFisio modulo="setorcomfisio" />
            <QtdModulo texto="EMERGÊNCIA" modulo="emergencia" />
            <Emergencia modulo="emergencia" />
            <QtdModulo texto="UTI" modulo="uti" />
            <Uti modulo="uti" />
            <QtdModulo texto="UCI" modulo="uci" />
            <Uci modulo="uci" />
            <QtdModulo texto="UCIN" modulo="ucin" />
            <Ucin modulo="ucin" />
            <QtdModulo texto="ENFERMARIA" modulo="enfermaria" />
            <Enfermaria modulo="enfermaria" />
            <QtdModulo texto="EQUIPE DE TRANSPORTE" modulo="transporte" />
            <Transporte modulo="transporte" />
            <QtdModulo texto="AMBULATÓRIO" modulo="ambulatorio" />
            <Ambulatorio modulo="ambulatorio" />
            <QtdModulo texto="PROGRAMA DE RESIDÊNCIA" modulo="residencia" />
            <Residencia modulo="residencia" />
            <QtdModulo texto="ATRIBUIÇÕES EXTRA-PROFISSIONAL" modulo="atribuicoes" />
            <AtribuicoesExtra modulo="atribuicoes" />
            <QtdModulo texto="CENTRO ESPECIALIZADO DE REABILITAÇÃO" modulo="cer" />
            <CER modulo="cer" />
            <QtdModulo texto="OUTROS DADOS DA FISCALIZAÇÃO" modulo="outrosDados" />
            <OutrosDados modulo="outrosDados" />
            <QtdModulo texto="ORIENTAÇÕES/NOTIFICAÇÕES" modulo="orientacoes" />
            <OrientacoesNotificacao modulo="orientacoes" />
        </>
    )
}

export default Livre
